module.exports = __webpack_public_path__ + "static/media/previous.d8bd8efc.png";